var React = require('react');

function AngularPlain (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M148.527 191.167H177.909H207.291L177.909 120.478L148.527 191.167Z","fill":"#ff4d4f","key":0}),React.createElement("path",{"d":"M177.909 9L17 66.3811L41.5425 279.141L177.909 354.669L314.276 279.141L338.818 66.3811L177.909 9ZM278.326 272.746H240.821L220.599 222.278H177.909H135.219L114.997 272.746H77.4921L177.909 47.1965L278.326 272.746Z","fill":"#ff4d4f","key":1})]);
}

AngularPlain.defaultProps = {"viewBox":"0 0 355 355","fill":"none"};

module.exports = AngularPlain;

AngularPlain.default = AngularPlain;
